export default {"src":"/_next/static/media/logo-msu-white.e2687398.svg","height":177,"width":417,"blurWidth":0,"blurHeight":0};